import React from "react";
import { useHistory } from "react-router-dom";
import { WSPageToolbar } from "@wingspanhq/fe-component-library";
import { RequirementContextType } from "../../../../Requirements/types";
import { useRequirementsConfig } from "../../../../Requirements/useRequirementsConfig";
import {
  PAYEES_ROOT_PATH,
  useGoToPayeeDetailsRequirements
} from "../../../utils";
import { RequirementDetailsContent } from "../../../../Requirements/components/RequirementsDetails/RequirementDetailsContent";
import { Payee, PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";
import { selectorCounterpartyDisplayName } from "../../../../../shared/selectors/selectorCounterpartyDisplayName";

type RequirementsDetailsProps = {
  /**
   * The contractor entity, not the search row: the search index is currently
   * unstable and the parent no longer depends on it. Only the id and a display
   * name are read here.
   */
  payee: Payee;
  requirement: PayeeRequirement;
};

export const RequirementsDetailsRoute: React.FC<RequirementsDetailsProps> = ({
  payee,
  requirement
}) => {
  const history = useHistory();
  const goToPayeeDetailsRequirements = useGoToPayeeDetailsRequirements();

  const requirementConfig = useRequirementsConfig({
    requirements: [requirement],
    contextType: RequirementContextType.Payee
  });

  const title = requirementConfig.getRequirementName(requirement);

  return (
    <>
      <WSPageToolbar
        actions={requirementConfig.getToolbarActions(requirement)}
        breadcrumbs={[
          {
            label: "Contractors",
            onClick: () => {
              history.push(PAYEES_ROOT_PATH);
            }
          },
          {
            label: selectorCounterpartyDisplayName(payee),
            onClick: () => {
              goToPayeeDetailsRequirements(payee.id!);
            }
          },
          {
            label: title || "Requirement"
          }
        ]}
      />

      <RequirementDetailsContent
        {...requirementConfig}
        contextType={RequirementContextType.Payee}
        requirement={requirement}
      />
    </>
  );
};
